// shown for anyone without a photo (the photo step on /welcome can be skipped)
const DEFAULT_PROFILE_PIC =
  "https://res.cloudinary.com/djrpmnbbi/image/upload/v1581093820/website-assets/deleted-user/profile-pic.jpg";

export default (url, height, width) => {
  return (url || DEFAULT_PROFILE_PIC).replace(
    "/image/upload/",
    `/image/upload/w_${width * 2},h_${height * 2},f_auto,q_auto/`
  );
};
